"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayOfWeekOf = void 0;
const types_1 = require("../types");
const getDayOfWeekOf = (date) => {
    const dayIndex = (date.getDay() + 6) % 7;
    return types_1.daysOfWeek[dayIndex];
};
exports.getDayOfWeekOf = getDayOfWeekOf;
